import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d806c2b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "time-slot-sector-checkbox__sector" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_checkbox = _resolveComponent("checkbox")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["time-slot-sector-checkbox", { 'checkbox--disabled': _ctx.disabled }]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    _createVNode(_component_checkbox, { value: _ctx.checked }, null, 8, ["value"]),
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.sector.name), 1)
  ], 2))
}